import { render, staticRenderFns } from "./RecipientAccount.vue?vue&type=template&id=efe18edc&scoped=true"
import script from "./RecipientAccount.vue?vue&type=script&lang=js"
export * from "./RecipientAccount.vue?vue&type=script&lang=js"
import style0 from "./RecipientAccount.vue?vue&type=style&index=0&id=efe18edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe18edc",
  null
  
)

export default component.exports